import { NeuroMessage, useProducts, useUser } from '@ignitesales/neuro-application/src/neuro-guide';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { isProdExactly } from '../utils/getRunMode';
import CartProduct from './CartProduct';

const Cart = ({ className, closeBtn, isOpen, onClose, lead={}, triggerContactForm, leadTransmitted }) => {
  const {
    productCart
  } = useProducts();

  const classes = classnames(className, 'cart');
  const cartHeader = <NeuroMessage id="cart.header" tagName='h2' />;
  const cartEmpty = <NeuroMessage id="cart.empty" tagName='h2' />;
  const cartEmptyMessage = <NeuroMessage id="cart.empty.message" tagName='p' />;
  const cartEmptyButton = <NeuroMessage id="cart.empty.button" />;
  const messageContext = useNeuroMessages();
  const cartProductApply = messageContext.getMessage('cart.product.apply');
  const cartProductUpstart = messageContext.getMessage('cart.product.upstart');
  const cartProductHomeLoan = messageContext.getMessage('cart.product.homeLoan');
  const cartProductLendingSpecialist = messageContext.getMessage('cart.product.lendingSpecialist');
  const { uuid } = useUser();
  const productCartArray = Array.from(productCart);
  const oaoBaseURL = isProdExactly() ? messageContext.getMessage('product.actionUrl.oaoProduction') : messageContext.getMessage('product.actionUrl.oaoTesting');
  const formattedPhone = lead.phone && lead.phone.replace(/[^0-9]/g, '');
  const contactInfoFromForm = '&utm_source=enlighten&firstName='+lead.firstName+'&lastName='+lead.lastName+'&email='+lead.email+'&phoneNo='+formattedPhone;
  const [selectedProducts, setSelectedProducts] = useState(
    productCartArray.filter( product => messageContext.getMessage(`${product}.action.type`) === 1 )
  );

  const handleProductToggle = product => {
    if (selectedProducts.includes(product)) {
      setSelectedProducts(selectedProducts.filter(id => id !== product))
    } else {
      setSelectedProducts([...selectedProducts, product])
    }
  }

  const filterProductCategory = (actionType) => {
    return productCartArray.
      filter( product => messageContext.getMessage(`${product}.action.type`) === actionType ).
      map( product => {
        const actionType = messageContext.getMessage(`${product}.action.type`);
        return <CartProduct product={ product } actionType={ actionType } selectedProducts={selectedProducts} handleProductToggle={ handleProductToggle } />;
      }
    );
  }

  const defineProductCode = (actionType) => {
    return productCartArray.
      filter( product => messageContext.getMessage(`${product}.action.type`) === actionType ).
      map( product => messageContext.getMessage(`${product}.action.productCode`)
    );
  }

  const defineDepositProductCode = () => selectedProducts.map ( product => messageContext.getMessage(`${product}.action.productCode`) );

  const buildProductButton = (url, buttonText, classes) => {
    return <a
      href={ leadTransmitted ? url : null }
      onClick={ !leadTransmitted ? triggerContactForm : null }
      className={`btn btn-primary ${classes}`}
      target="_blank">{ buttonText }
    </a>
  }

  //************************************************************************//
  //************************* ALL DEPOSIT PRODUCTS *************************//
  //************************************************************************//
  const depositProducts = filterProductCategory(1);
  const depositProductsSuccessURL = () => {
    const productCode = defineDepositProductCode()
    const productCodeURL = '?productCode='+productCode;
    return oaoBaseURL + productCodeURL + contactInfoFromForm;
  }
  const classname = selectedProducts.length === 0 ? 'disabled' : null;
  const depositProductsButton = buildProductButton(depositProductsSuccessURL(), cartProductApply, classname);


  //************************************************************************//
  //************************* HELOC ONLY ***********************************//
  //************************************************************************//
  const lineOfCredit = filterProductCategory(2);
  const lineOfCreditSuccessURL = () => {
    const productCode = defineProductCode(2)
    const productCodeURL = '?productCode='+productCode;
    return oaoBaseURL + productCodeURL + contactInfoFromForm;
  }
  const lineOfCreditButton = buildProductButton(lineOfCreditSuccessURL(), cartProductApply);


  //************************************************************************//
  //************************* AUTO LOAN ONLY *******************************//
  //************************************************************************//
  const autoLoan = filterProductCategory(3);
  const autoLoanSuccessURL = () => {
    const productCode = defineProductCode(3);
    const productCodeURL = '?productCode='+productCode;
    return oaoBaseURL + productCodeURL + contactInfoFromForm;
  }
  const autoLoanButton =  buildProductButton(autoLoanSuccessURL(), cartProductApply);


  //************************************************************************//
  //************************* CASH BACK VISA ONLY **************************//
  //************************************************************************//
  const cashBackVisa = filterProductCategory(4);
  const cashBackVisaSuccessURL = () => {
    const productCode = defineProductCode(4)
    const productCodeURL = '?productCode='+productCode;
    return oaoBaseURL + productCodeURL + contactInfoFromForm;
  }
  const cashBackVisaButton = buildProductButton(cashBackVisaSuccessURL(), cartProductApply);


  //************************************************************************//
  //************************* PLATINUM VISA ONLY ***************************//
  //************************************************************************//
  const platinumVisa = filterProductCategory(5);
  const platinumVisaSuccessURL = () => {
    const productCode = defineProductCode(5);
    const productCodeURL = '?productCode='+productCode;
    return oaoBaseURL + productCodeURL + contactInfoFromForm;
  }
  const platinumVisaButton = buildProductButton(platinumVisaSuccessURL(), cartProductApply);


  //************************************************************************//
  //************************* HOME LOAN ONLY *******************************//
  //************************************************************************//
  const homeLoan = filterProductCategory(6);
  const homeLoanButton = buildProductButton('#', cartProductHomeLoan, 'selected');


  //************************************************************************//
  //*********************** LENDING SPECIALIST *****************************//
  //************************************************************************//
  const lendingSpecialist = filterProductCategory(11);
  const lendingSpecialistButton = buildProductButton('#', cartProductLendingSpecialist, 'selected');


  //************************************************************************//
  //************************* UPSTART PRODUCTS ONLY ************************//
  //************************************************************************//
  const upstartProducts = filterProductCategory(7);
  const upstartBaseURL = messageContext.getMessage('product.actionUrl.upstart');
  const upstartButton = buildProductButton(upstartBaseURL, cartProductUpstart);


  const renderAllProducts = () => {
    return productCartArray ?

      <div className="modal__content">

        <div className="modal__content--header">
          { cartHeader }
          <div className="shareResults">
            <NeuroMessage id="uuidMessage" values={ { uuid } } tagName='p' />
          </div>

          <div className="modal__content--products">

            { depositProducts.length ?
              <div className="productContainer deposit">
                <div className="productContainer__products">
                  { depositProducts }
                </div>
                { depositProductsButton }
              </div>
            : null }

            { lineOfCredit.length ?
              <div className="productContainer">
                <div className="productContainer__products">
                  { lineOfCredit }
                </div>
                { lineOfCreditButton }
              </div>
            : null }

            { autoLoan.length ?
              <div className="productContainer">
                <div className="productContainer__products">
                  { autoLoan }
                </div>
                { autoLoanButton }
              </div>
            : null }

            { cashBackVisa.length ?
              <div className="productContainer">
                <div className="productContainer__products">
                  { cashBackVisa }
                </div>
                { cashBackVisaButton }
              </div>
            : null }

            { platinumVisa.length ?
              <div className="productContainer">
                <div className="productContainer__products">
                  { platinumVisa }
                </div>
                { platinumVisaButton }
              </div>
            : null }

            { upstartProducts.length ?
              <div className="productContainer">
                <div className="productContainer__products">
                  { upstartProducts }
                </div>
                { upstartButton }
              </div>
            : null }

            { homeLoan.length ?
              <div className="productLoanContainer">
                <div className="productContainer">
                  <div className="productContainer__products">
                    { homeLoan }
                  </div>
                  { homeLoanButton }
                </div>
                <div className="messageContainer">
                  <NeuroMessage id="cart.product.homeLoan.emailAdvice" tagName='span' />
                </div>
              </div>
            : null }

            { lendingSpecialist.length ?
              <div className="productLoanContainer">
                <div className="productContainer">
                  <div className="productContainer__products">
                    { lendingSpecialist }
                  </div>
                  { lendingSpecialistButton }
                </div>
                <div className="messageContainer">
                  <NeuroMessage id="cart.product.lendingSpecialist.emailAdvice" tagName='span' />
                </div>
              </div>
            : null }

          </div>

        </div>
      </div>
    : <div className="emptyCart">
        { cartEmpty }
        { cartEmptyMessage }
        <button className="btn btn-primary" onClick={ onClose }>{ cartEmptyButton }</button>
      </div>
  }

  return (
    <Modal
      show={isOpen}
      className={classes}
      onClose={onClose}
      closeBtn={closeBtn}
      nodeId="root"
    >

      { renderAllProducts() }

    </Modal>
  );
};
Cart.propTypes = {
  className: PropTypes.string,
  closeBtn: PropTypes.any,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Cart;